import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { CategoriesContainer } from './container';
import { CategoriesV2 } from './v2';

export const CategoriesVersion: FC = () => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <CategoriesV2 />;
  return <CategoriesContainer />;
};
